import classes from "~/pages/WishlistPage/components/WishlistDetails/components/WishlistItem/WishlistItem.module.less";
import { IconButton, type SvgIconProps } from "~/common/mui";
import { ToggleCommentIcon } from "~/common/components/icon/ToggleCommentIcon";

interface CommentButtonProps {
  className?: string;
  onClick: () => void;
  open: boolean;
  fontSize?: SvgIconProps["fontSize"];
}

export const CommentButton = ({ className, onClick, open, fontSize }: CommentButtonProps) => (
  <IconButton onClick={onClick} data-test-id={"btn-toggle-comment"} color={"primary"} className={className}>
    <ToggleCommentIcon className={classes.icon} fontSize={fontSize} open={open} />
  </IconButton>
);
